import { useCallback } from 'react';
import styled from 'styled-components';
import { AppAudioPlayerControlsCross } from '@elfsight/icons';
import { InteractiveOnDeactivation } from '@elfsight/widget-deactivation';
import { getColorWithAlpha } from '@elfsight/widget-utils';
import { useSettings } from '@wu/widget-core';
import type { PropsWithClassName } from '../../../../../types';
import { useTheme } from '../../../common';
import { usePlayer } from '../../PlayerProvider';
import type { DefaultButtonProps } from './DefaultButton';
import { DefaultButton } from './DefaultButton';

type CloseButtonProps = PropsWithClassName &
  DefaultButtonProps & {
    iconSize?: number;
    styles?: string;
    _float?: boolean;
  };

export function CloseButton({
  className,
  iconSize = 12,
  styles,
  ...forwardingProps
}: CloseButtonProps) {
  const { setClosePlayer } = usePlayer();
  const { textColor } = useTheme();
  const { messageClosePlayer, displayDeactivation } = useSettings();

  const switchPlayer = useCallback(() => {
    setClosePlayer();
  }, [setClosePlayer]);

  return (
    <InteractiveOnDeactivation isInteractive={displayDeactivation}>
      <StyledCloseButtonComponent
        {...forwardingProps}
        className={className}
        onClick={switchPlayer}
        title={messageClosePlayer}
        _styles={styles}
      >
        <StyledIcon
          as={AppAudioPlayerControlsCross}
          fill={getColorWithAlpha(textColor, 1)}
          _size={iconSize}
        />
      </StyledCloseButtonComponent>
    </InteractiveOnDeactivation>
  );
}

export const StyledCloseButtonComponent = styled(DefaultButton)<{
  _float?: boolean;
}>`
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
  padding: 4px;

  ${({ _float }) =>
    _float &&
    `
      position: absolute;
      right: 0;
    `}

  ${({ _styles }) => _styles};
`;

const StyledIcon = styled.svg<{
  _size: number;
}>`
  width: ${({ _size }) => _size}px;
  height: ${({ _size }) => _size}px;
`;
